
const playStore = require("../../assets/img-google-play.png");
const ios = require("../../assets/img-apple-store.png");

export const listApps = [
  { id: "playStore", icon: playStore, link: "https://play.google.com/store/apps/details?id=io.cashway.planium.app", alt: "img-playStore" },
  { id: "ios", icon: ios, link: "https://apps.apple.com/br/app/planium-bank/id1580119779", alt: "img-ios" },

]